import { useForm } from "@refinedev/react-hook-form";
import { useNavigation } from "@refinedev/core";
import { useProgressbar } from "@utils/notifications";
import { DefaultTemplate } from "@components/templates/default";
import { FaChevronLeft } from "react-icons/fa6";

export const UserEdit: React.FC = () => {
  const {
    refineCore: { onFinish, formLoading },
    register,
    handleSubmit,
    // resetField,
    formState: { errors },
  } = useForm({
    refineCoreProps: {
      meta: {
        fields: ['id', 'name', 'status', 'description']
      }
    }
  });

  const { goBack } = useNavigation()
  useProgressbar(formLoading, 5)

  // const { options } = useSelect({
  //   resource: "options",
  //   defaultValue: queryResult?.data?.data.category.id,
  //   meta: {
  //     fields: [...]
  //   }
  // });

  // useEffect(() => {
  //   // resetField("category.id");
  // }, [options]);

  // logger.debug(error)

  return (
    <DefaultTemplate
      left={
        <button className="btn btn-back" onClick={goBack}>
          <FaChevronLeft />
          <span>Back</span>
        </button>
      }
    // right={
    //   formLoading && <Preloader />
    // }
    >
      <div className="card bg-base-100 my-8 mx-2">
        <div className="card-body">
          <form onSubmit={handleSubmit(onFinish)}>
            <fieldset className="fieldset">
              <legend>User Information</legend>
              <label className="label" htmlFor="name">Name</label>
              <input
                className="input input-form"
                type="text"
                placeholder="Your name"
                {...register("name", { required: true })}
              />
              {errors.name && <label className="label">
                <span>Please write a name</span>
              </label>}

              <label className="label" htmlFor="status">Status</label>
              <select
                className="select select-form"
                {...register("status", { required: true })}
              >
                <option value="active">active</option>
                <option value="inactive">inactive</option>
              </select>
              {errors.name && <label className="label">
                <span>Please choose a status</span>
              </label>}

              <label className="label" htmlFor="description">Description</label>
              <textarea
                className="textarea textarea-form resize-none"
                placeholder="..."
                {...register("description")}
              />
              {errors.description && <label className="label">
                <span>Please choose a status</span>
              </label>}
            </fieldset>

            <button className="btn btn-primary w-full my-2" type="submit">Submit</button>
          </form>
        </div>
      </div>
    </DefaultTemplate >
  );
};
